module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "workoutModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-fluid rounded",
    attrs: {
      "src": _vm.pictures && _vm.pictures.length && _vm.pictures[0],
      "alt": _vm.name
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.description))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-405affcc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkoutComponent.vue
// module id = 51
// module chunks = 0